// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__Vi9Pb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__38o58"};